/* eslint-disable */

import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import AppFormDialog from "components/common/AppFormDialog";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MachineInventoryTable from "layouts/machine/MachineInventoryTable";
import machineTableData from "layouts/machine/data/machineTableData";
import UpdateMachineForm from "forms/machine/updateMachineForm";
import machineService from "services/machineService";

function InUseMachines() {
  const navigate = useNavigate();
  const location = useLocation();
  const [machines, setMachines] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [machineToEdit, setMachineToEdit] = useState(null);

  const loadInUse = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await machineService.getInUseMachinesWithDetails();
      setMachines(data || []);
    } catch (error) {
      console.error("Error al cargar máquinas en uso:", error);
      setMachines([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadInUse();
  }, [loadInUse, location.key]);

  useEffect(() => {
    const onFocus = () => loadInUse();
    const onVisibility = () => {
      if (document.visibilityState === "visible") loadInUse();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [loadInUse]);

  const handleOpenEdit = (machineId) => {
    const machine = machines.find((item) => item.Id === machineId);
    if (!machine) return;
    setMachineToEdit({
      ...machine,
      MachineTypeId: machine.MachineType?.Id ?? machine.MachineTypeId ?? null,
    });
  };

  const handleCloseEdit = () => setMachineToEdit(null);
  const editDialogTitle = useMemo(() => {
    const type = machineToEdit?.MachineType?.Type || machineToEdit?.MachineTypeLabel || "";
    const name = machineToEdit?.Name || machineToEdit?.Machine?.Name || "";
    const serial = machineToEdit?.SerialNumber || "";
    return ["Editar máquina", type, name, serial].filter(Boolean).join(" ");
  }, [machineToEdit]);

  const handleUpdateSuccess = async (updatedId) => {
    const id = updatedId ?? machineToEdit?.Id;
    try {
      if (!id) return;
      const updated = await machineService.getMachineByIdWithDetails(id);
      if (updated) {
        setMachines((previous) =>
          previous.map((machine) => (machine.Id === id ? updated : machine))
        );
      }
    } finally {
      await loadInUse();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <MDTypography variant="h6" color="white">
                  Máquinas en uso
                </MDTypography>
                <Button color="inherit" onClick={() => navigate("/machine")}>
                  Volver a disponibles
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <MachineInventoryTable
                  machines={machines}
                  makeTable={(listed) =>
                    machineTableData({
                      machinesDetails: listed,
                      expectedLocalType: "Comercio",
                      onEdit: handleOpenEdit,
                      hideDelete: true,
                      typeFirst: true,
                    })
                  }
                  expectedLocalType="Comercio"
                  tableName="máquinas en uso"
                  isLoading={isLoading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      {machineToEdit && (
        <AppFormDialog open onClose={handleCloseEdit} title={editDialogTitle}>
          <UpdateMachineForm
            closeForm={handleCloseEdit}
            machine={machineToEdit}
            onUpdateSuccess={handleUpdateSuccess}
          />
        </AppFormDialog>
      )}
    </DashboardLayout>
  );
}

export default InUseMachines;
